import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Aggregate as View } from 'ui-components/components/molecules/Visualization/Aggregate'
import { BoundaryDimensionalDisplay } from '~map-preview/App/Tools/MapToolbar/Aggregate/BoundaryDimensionalDisplay'
import {
  setAggregate,
  setAggregateProperty,
  useAggregateProperty
} from '~map-preview/states/boundaries'
import { useNumericProperties } from '~map-preview/states/map'
import { useMapToolbarStore } from '~map-preview/states/mapToolbar'
import { Aggregate as AggregateType } from '~map-preview/types/__generated/gql/graphql'

import {
  LAYER_TYPES,
  LAYER_TYPE_TITLE,
  setLayerType,
  setLayerTypeTitle
} from '~map-preview/states/layerType'
import { openMapLegend } from '~map-preview/states/ui'

export const Aggregate = () => {
  const dispatch = useDispatch()
  const { visualization } = useMapToolbarStore()
  const numericProperties = useNumericProperties()
  const aggregateProperty = useAggregateProperty()

  const properties = [
    { label: 'Location count', name: 'count' } as any,
    ...numericProperties
  ]

  useEffect(() => {
    if (visualization) {
      const selected: AggregateType | undefined =
        visualization &&
        (Object.values(visualization)[0] as AggregateType | undefined)

      if (selected?.type === 'aggregate') {
        dispatch(
          setAggregateProperty(
            selected.aggregate ? selected.aggregate : aggregateProperty
          )
        )
        dispatch(setAggregate(selected.property))
        dispatch(setLayerType(LAYER_TYPES.BOUNDARIES))
        dispatch(setLayerTypeTitle(LAYER_TYPE_TITLE[LAYER_TYPES.BOUNDARIES]))
        dispatch(openMapLegend())
      }
    }
  }, [visualization])

  const handleChange = (event) => {
    dispatch(setAggregateProperty(event.target.value))
  }

  return (
    <>
      <View
        value={aggregateProperty}
        options={properties}
        onChange={handleChange}
      />
      <BoundaryDimensionalDisplay />
    </>
  )
}
